export default __webpack_public_path__ + "static/media/point.a3218cb4.svg";